/**
 * Rounds a number to the specified precision.
 *
 * @param numberToFix - The number to round.
 * @param fixPrecision - The number of decimal places to round to. Default is 2.
 * @returns The fixed number.
 */
export function precisionNumber(numberToFix: number, fixPrecision = 2): number {
  return Number(numberToFix.toFixed(fixPrecision))
}
